import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SortArrowIcon } from './SVGIcon';
import cn from './cn';

export function TableSortArrow({ name, sortedColumn, sortBy }) {
    const [searchParams] = useSearchParams();

    const param = useMemo(
        () => ({
            'order-by': searchParams.get('order-by')
        }),
        [searchParams]
    );

    const orderName = Object.values(param)[0];

    // if (orderName?.length && orderName !== name) {
    //     return null;
    // }
    // if (orderName?.length && orderName !== name && name?.length) {
    //     return <span>0</span>;
    // }
    return (
        <SortArrowIcon
            className={cn(`w-2 h-5 inline-block ml-2.5 rotate-0 text-[#CDD5D8]`, {
                'rotate-180': sortedColumn === name && sortBy === 'desc',
                'text-secondary': orderName?.length && orderName === name && name?.length
            })}
        />
    );
}

export default null;
